import { render, staticRenderFns } from "./messages-component.vue?vue&type=template&id=2d5fe236&lang=html&"
import script from "./messages-component.vue?vue&type=script&lang=js&"
export * from "./messages-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports